import * as React from "react";
import { SelectInput, required } from "react-admin";

const createGasBrandMerchant = () => (
  <SelectInput
    sx={{
      width: "20%",
      "@media (max-width:900px)": {
        width: "100%",
      },
    }}
    source="qr_type"
    validate={[required()]}
    choices={[
      { id: "Datex", name: "Datex" },
      { id: "ITBI", name: "ITBI" },
    ]}
  />
);

export default createGasBrandMerchant;
